import { createStore } from 'vuex'

export default createStore({
	state: {
        operation:{},
        usertype:'',
        store_id:'',
        unit:'',
        query:{}
	},
	mutations: {
        setOperation(state,data){
            state.operation = data
        },
        setUsertype(state,data){
            state.usertype = data
        },
        setQuery(state,data){
            state.query = data
        },
	},
	actions: {
	},
	modules: {
	}
})
